import { gql } from "apollo-boost";
import Success from 'components/alerts/Success';
import { Card } from 'components/common/card/Card';
import { Text } from 'components/common/form/modules/input/Text';
import { updateCurrentUser } from 'components/graphql/queries';
import { closeModal, openModal } from 'components/modal/modules/dispatcher/methods';
import * as React from 'react';
import { Subscription } from "react-apollo";
import { withCookies } from 'react-cookie';
import { connect } from 'react-redux';
import { Redirect } from 'react-router'
import { fetchGraphQL } from 'services/graphql/GraphQL';
import UserDucks from 'stores/ducks/User.duck';


interface ISettingsPageProps {
	user: any;
	cookies?: any;
	dispatch?: any;
}
class SettingsPage extends React.Component<ISettingsPageProps,
	{
		name: string;
		lastName: string;
		password: string;
		passwordRepeat: string;
		message: string | null;
		success: boolean;
		change: boolean;
	}> {

	constructor(props) {
		super(props);
		this.state = {
			name: props.user.name,
			lastName: props.user.lastname,
			password: '',
			passwordRepeat: '',
			message: null,
			success: false,
			change: false
		};
		this.handleSubmit = this.handleSubmit.bind(this);
		this.openConfirmChangesModal = this.openConfirmChangesModal.bind(this);
		this.handleRoleChange = this.handleRoleChange.bind(this)
	}

	public handleRoleChange(user: any) {
		this.props.dispatch(UserDucks.setUser(user));
		return undefined;
	}


	public componentWillReceiveProps(nextProps) {
		if (this.state.change) {
			return;
		}
		const { name, lastname } = nextProps.user;
		this.setState({
			name,
			lastName: lastname,
		});
	}

	public onChange = (e: any) => {
		const newState = this.state;
		newState[e.target.name] = e.target.value;
		this.setState({ ...newState, change: true, success: false, message: '' });
	};

	public handleSubmit() {
		if (!this.state.change) {
			return;
		}
		const { name, lastName, password, passwordRepeat } = this.state;
		this.setState({ success: false, change: false });
		if (name.length < 3) {
			this.setState({
				message: 'First name has to be at least 3 characters long',
			});
			return;
		}
		if (lastName.length < 1) {
			this.setState({
				message: 'Last name has to be at least 1 character long',
			});
			return;
		}
		if (password !== '' && passwordRepeat !== '') {
			if (password.length < 6) {
				this.setState({
					message: 'Password has to be at least 6 characters long',
				});
				return;
			}
			if (passwordRepeat !== password) {
				this.setState({ message: 'Passwords do not match' });
				return;
			}
		} else if (password === '' && passwordRepeat !== '') {
			this.setState({
				message: 'Enter password',
			});
			return;
		} else if (password !== '' && passwordRepeat === '') {
			this.setState({
				message: 'Enter password again',
			});
			return;
		} else {
			this.setState({
				message: 'Enter password',
			});
			return;
		}
		const email = this.props.user.email
		fetchGraphQL(updateCurrentUser(), undefined, {
			email,
			name,
			lastname: lastName,
			password,
		}).then(data => {

			const user = this.props.user;
			user.name = name;
			user.lastname = lastName;
			delete user.password;
			user.username = email
			this.props.dispatch(
				UserDucks.setUser(user)
			)
			const deepCopyOfUser = JSON.parse(JSON.stringify(this.props.user))
			delete deepCopyOfUser.events;
			deepCopyOfUser.username = deepCopyOfUser.email;
			deepCopyOfUser.fullname = deepCopyOfUser.name + ' ' + deepCopyOfUser.lastname;
			const userCookie = this.props.cookies.get("user");
			if (userCookie.token) {
				deepCopyOfUser.token = userCookie.token;
				this.props.cookies.remove("user", { path: "/" });
				this.props.cookies.remove("token", { path: "/" });
				const date = new Date(); date.setDate(date.getDate() + 7);
				this.props.cookies.set("user", deepCopyOfUser, { path: "/", expires: date });
				this.props.cookies.set("token", deepCopyOfUser.token, { path: "/", expires: date });
			}

		});
	}

	public openConfirmChangesModal() {
		if (!this.state.change) {
			return;
		}
		const content = <div>
			<p>
				Click confirm to save changes.<br /><br />
			</p>
			<div className="Seperate-Buttons">
				<button
					className='new-button-white-3'
					style={{ border: 'none' }}
					onClick={e => closeModal()}
				>
					CANCEL
                </button>
				<button
					className="new-button-white-3"
					style={{ border: 'none' }}
					onClick={e => {
						this.handleSubmit();
						closeModal();
					}}
				>
					CONFIRM
            	</button>
			</div>
		</div>
		openModal(content, "Update Account");
	}

	public render() {

		const roleChange = gql`
		subscription {
		  roleChange
		}
		`;

		return (
			<div style={{ paddingRight: '0 auto', paddingLeft: '0 auto', justifyContent: 'center', width: '100%' }} className="changeable-width-support">
				<div className="changeable-width">
					<Subscription subscription={roleChange}>
						{({ data }) => {
							if (data !== undefined && data !== null && data.roleChange !== null && data.roleChange.length !== 0) {
								const events = {}
								Object.keys(this.props.user.events).map((key) => {
									if (this.props.user.events[key].id === data.roleChange[1]) {
										events[key] = { id: this.props.user.events[key].id, roles: [data.roleChange[2]] }
									} else {
										events[key] = this.props.user.events[key]
									}
								});
								const newUser = {
									...this.props.user,
									events
								}
								this.handleRoleChange(newUser);
								return <Redirect to="/manage/events" />;
							}
							return null;
						}}
					</Subscription>
					<p><br /></p>
					<Card className='mb-2' style={{ borderRadius: '15px' }} >
						<div className='div_holder_3' style={{ display: 'flex', justifyContent: 'center' }}>
							<div>
								<p><br /></p>
								<h3 style={{ color: '#020102' }}>Account Settings</h3>
								<p><br /><br /></p>
								<Text
									label='Email'
									name='email'
									value={this.props.user.email}
									disabled={true}
								/>
								<Text
									label='First name *'
									name='name'
									value={this.state.name}
									onChange={this.onChange}
								/>
								<Text
									label='Last name *'
									name='lastName'
									value={this.state.lastName}
									onChange={this.onChange}
								/>
								<Text
									label='New password *'
									name='password'
									onChange={this.onChange}
									value={this.state.password}
								/>
								<Text
									label='Repeat new password *'
									name='passwordRepeat'
									onChange={this.onChange}
									value={this.state.passwordRepeat}
								/>
								{this.state.message ? (
									<div className='alert alert-danger'>{this.state.message}</div>
								) : null}
								<p />
								<button onClick={e => {
									e.preventDefault();
									this.openConfirmChangesModal();
								}} className="new-button-save" style={{ float: "right", border: 'none' }}>Save</button>
								<p>
									<br /><br />
									{this.state.success ? <Success content="Account details updated" /> : null}
									<br /><br />
								</p>
							</div>
						</div>
					</Card>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		user: UserDucks.getUser(state)
	};
};

const x = withCookies(SettingsPage)
export default connect(mapStateToProps)(x);



// WEBPACK FOOTER //
// ./src/pages/auth/Settings.page.tsx